export const theme = {
  colors: {
    primaryColor: '#52585E',
    lightGray: '#e5e5e5',
    light: '#ffffff',
  },
  mediaQueries: {
    desktop: '1200px',
    tablet: '768px',
    mobile: '320px',
  },
  media: {
    xs: '375px',
    sm: '600px',
    md: '960px',
    lg: '1200px',
    xl: '1600px',
  },
  fonts: {
    textFont: 'Quicksand',
    headerFont: 'Abril Fatface',
    defaultFontSize: '16px',
  },
  fontWeight: {
    normal: '400',
    bold: '700',
  },
  headers: {
    h1: '80px',
    h2: '36px',
    h3: '30px',
    h4: '24px',
    h5: '20px',
    h6: '16px',
  },
};
